export const EVA_API_HOST = "https://brilliantapi.evasolutions.eu";
export const EVA_API_VERSION = "api/v1";
